/**
 * Environmental Module
 *
 * @version 2.0
 * @updated 2026-02-23
 * @module core/modules/environmental
 *
 * @description
 * Módulo de Gestión Ambiental Urbana para WESTEER.
 * Sistema completo de 3 capas: Inventario, Indicadores, Intervenciones.
 *
 * @remarks
 * **Características**:
 * - UI State Machine con 5 modos operacionales
 * - 3 paneles coordinados (Layers, Toolbar, Context)
 * - Presets rápidos para flujos comunes
 * - Gestión de inventario verde
 * - Análisis de indicadores ambientales
 * - Priorización de intervenciones
 *
 * **Auto-registro**:
 * Este módulo se auto-registra en el moduleRegistry al importarse.
 */

import { moduleRegistry } from '../../module-registry';
import { TabbedLeftPanel } from '../../layouts/panels/LeftPanel/TabbedLeftPanel';
import { EnvironmentalToolbarContent } from './components';

// Store
export {
  useEnvironmentalUIStore,
  useOperationalModeStore,
  selectMode,
  selectActiveTool,
  selectActiveLayerSet,
  selectSelection,
  selectHasSelection,
  selectRightPanelView,
  selectToolParams,
  selectIsInventory,
  selectIsAnalyzing,
  selectIsPlanning,
} from './store';

export type {
  EnvironmentalMode,
  EnvironmentalTool,
  OperationalMode,
  OperationalTool,
  LayerPreset,
  SelectionType,
  RightPanelView,
  Selection,
  ToolParams,
  EnvironmentalUIState,
  EnvironmentalUIActions,
  EnvironmentalUIStore,
} from './store';

// Hooks
export { useEnvironmentalUI } from './hooks';
export type { EnvironmentalUIHook } from './hooks';

// Components
export {
  EnvironmentalLayersPanel,
  EnvironmentalToolbarContent,
  EnvironmentalContextPanel,
} from './components';

export type {
  EnvironmentalLayersPanelProps,
  EnvironmentalContextPanelProps,
} from './components';

// Pages
export { EnvironmentalDemoPage } from './pages';

/* ===== AUTO-REGISTRO DEL MÓDULO ===== */

/**
 * Registra el módulo Environmental en el registry
 *
 * @remarks
 * Este código se ejecuta cuando el módulo es importado.
 * El leftPanel es TabbedLeftPanel (panel genérico ambiental).
 * No necesita provider especial.
 */
moduleRegistry.register({
  id: 'environmental',
  leftPanel: TabbedLeftPanel,
  toolbar: {
    content: EnvironmentalToolbarContent,
  },
  // No requiere provider especial
  // No requiere realtime
  enabledByDefault: true,
});
